module.exports = __webpack_public_path__ + "img/motion.79d0c5c4.png";